import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
  LOAD_KYC_CONTACT_FILE_URL,
  LOAD_KYC_CONTACT_DETAIL,
  LOAD_KYC_CONTACT_LIST,
} from 'state/actionTypes';
import * as api from 'api/kyc/kycContact';
import * as toast from 'state/toast/actions';
import { isAlicloudUrl } from 'utils/fileUtils';
import {
  setKycContactListData,
  setKycContactListLoading,
  setKycContactDetailData,
  setKycContactDetailLoading,
  setKycContactFileUrl,
} from 'state/kyc/actions';

export function* loadKycContactList({ payload }) {
  const { page, size, filters } = payload;
  yield put(setKycContactListLoading(true));
  try {
    const response = yield call(api.getKycContacts, page, size, filters);
    yield put(setKycContactListData(response.data.data, response.data.paging));
  } catch (error) {
    yield put(
      toast.errorMessage('Load KYC contact list failed', error.message)
    );
  } finally {
    yield put(setKycContactListLoading(false));
  }
}

export function* loadKycContactDetail({ payload }) {
  const { id } = payload;
  yield put(setKycContactDetailLoading(true));
  try {
    const response = yield call(api.getKycContactDetail, id);
    yield put(setKycContactDetailData(response.data.data));
  } catch (error) {
    yield put(
      toast.errorMessage('Load KYC contact detail failed', error.message)
    );
  } finally {
    yield put(setKycContactDetailLoading(false));
  }
}

export function* loadKycContactFileUrl({ payload }) {
  const { contactId, fileId } = payload;
  yield put(setKycContactDetailLoading(true));
  const cachedUrl = yield select(state => state.kyc.detail.fileUrls[fileId]);
  if (cachedUrl) {
    if (!isAlicloudUrl(cachedUrl)) {
      window.open(cachedUrl, '_blank');
    }
    yield put(setKycContactDetailLoading(false));
    return;
  }

  try {
    const response = yield call(
      api.getKycContactDownloadUrl,
      contactId,
      fileId
    );
    const { url } = response.data.data;
    yield put(setKycContactFileUrl(fileId, url));
    if (!isAlicloudUrl(url)) {
      window.open(url, '_blank');
    }
  } catch (error) {
    yield put(
      toast.errorMessage('Get KYC file download url failed', error.message)
    );
  } finally {
    yield put(setKycContactDetailLoading(false));
  }
}

export default function*() {
  yield takeLatest(LOAD_KYC_CONTACT_LIST, loadKycContactList);
  yield takeLatest(LOAD_KYC_CONTACT_DETAIL, loadKycContactDetail);
  yield takeLatest(LOAD_KYC_CONTACT_FILE_URL, loadKycContactFileUrl);
}
